module.exports = "/_next/static/images/vancouver-reference-list-4bbd981fcd3b11798b4e5954bed90ad9.png";